import React, { useState } from "react";
import { Sparkles, Loader2, ChevronDown, ChevronUp } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function OpportunityExplainer({ opportunityId, opportunityKey }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [generatedAt, setGeneratedAt] = useState(null);

  const load = async () => {
    if (text) { setOpen((o) => !o); return; }
    setOpen(true);
    setLoading(true);
    try {
      const { data } = await api.get(`/ai/opportunity/${opportunityId}/explain`);
      setText(data.explanation);
      setGeneratedAt(data.generated_at);
    } catch (e) {
      toast.error(formatApiError(e));
      setOpen(false);
    } finally { setLoading(false); }
  };

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={load}
        className="inline-flex items-center gap-1.5 text-xs text-primary hover:underline"
        data-testid={`op-explain-${opportunityKey}`}
      >
        <Sparkles size={12} className="text-primary" />
        <span>Why this, for me?</span>
        {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </button>
      {open && (
        <div className="mt-2 rounded-md border border-primary/20 bg-primary/5 p-3" data-testid={`op-explain-body-${opportunityKey}`}>
          {loading ? (
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Loader2 size={12} className="animate-spin" /> Generating a personal reasoning for you…
            </div>
          ) : (
            <>
              <div className="text-sm text-primary whitespace-pre-wrap leading-relaxed">{text}</div>
              {generatedAt && (
                <div className="mt-2 text-[10px] text-muted-foreground italic">
                  AI-generated, grounded on your own data · not a diagnosis
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
